<div class="pictures-container">
    <div fxLayout=" row" *ngIf="!isLoading" fxLayoutGap="40px"
        style="padding-bottom: 60px; border-bottom: 1px solid rgba(222, 222, 222, 0.2);">
        <div class="logo-holder">
            <h4 style="margin-top: 0;  margin-bottom: 8px;font-size: 16px;">Project logo</h4>
            <p style=" font-size: 14px; color: rgba(222, 222, 222, 0.4); margin-top: 0">We recommend using a jpg, png at
                a 4:3 ratio. Image cannot exceed 1.5MB</p>
            <form [formGroup]="logoImageForm">
                <div style="position: relative; width: 180px; height: 91px; border: 1px solid #ebebeb; display: flex; justify-content: center; align-items: center"
                    (click)="chooseImage()">
                    <img src="./assets/images/default-images.svg" style="width: 80px; height: 80px"
                        *ngIf="!project.logo">
                    <input type="file" accept="image/jpeg,image/jpg,image/png,image/svg" (change)="onLogoChange($event)"
                        class="mt_10" id="img-upload">
                    <ng-container *ngIf="project.logo">
                        <div
                            style="width: 180px; height: 91px; border: 1px solid #ebebeb; display: flex; align-items: flex-end">
                            <img [src]="SERVER_URL + 'images/' + project.projectCode + '/images/' + project.logo.fileName"
                                style="width: 180px; height: 91px; object-fit: contain">


                            <!-- <p
                                style="position: absolute; bottom: 0; background: rgba(0,0,0,.5); color: #dedede; margin-top: 0; margin-bottom: 0; padding: 10px; width: calc(100% - 20px); display: flex; justify-content: space-between; align-items: center">
                                <span style="font-size: 12px">{{project.logo.fileName}}</span>
                                <mat-icon style="color: #dedede; cursor:pointer;" (click)="deleteLogo()">
                                    delete
                                </mat-icon>
                            </p> -->
                        </div>
                    </ng-container>
                </div>
            </form>

            <!-- <div style="margin-top: 10px">
                <form [formGroup]="logoImageForm" style="display: flex; flex-direction: column">
                    <input accept="image/*" type="file" formControlName="logo" multiple="" (change)="onLogoChange($event)">
                    <p *ngIf="isLogoTooLarge === true" style="color: #f44336; font-size: 14px">Logo image size cannot
                        exceed 1.5MB.</p>
                    <p *ngIf="hasLogo === true" style="color: #f44336; font-size: 14px">Please delete the current logo
                        before uploading a new one.</p>

                    <button mat-button [disabled]="this.logo.length === 0 || isLogoUploading === true"
                        [ngClass]="{'deactivated': this.logo.length === 0 || isLogoUploading === true, 'activated': this.logo.length !== 0 && !this.isLogoUploading}"
                        style="background: #4fb868; color: #dedede; width: fit-content; margin-top: 10px" (click)="uploadProjectLogo()">{{isLogoUploading ? 'Uploading...' :
                        'Upload'}}</button>
                </form>
            </div> -->
        </div>
    </div>
    <div style="padding-top: 50px; padding-bottom: 32px;" *ngIf="!isLoading">
        <h4 style="margin-bottom: 10px">Your Hero Images</h4>
        <p style="font-size: 14px; color: rgba(222, 222, 222, 0.4); margin-top: 0">Multiple images can be uploaded
            together. And each image cannot exceed 5MB</p>

        <form [formGroup]="galleryImageForm" style="display: flex; flex-direction: column">
            <input accept="image/*" type="file" class="form-control upload_input" multiple="" formControlName="gallery"
                (change)="onGalleryImageChange($event)">
            <p *ngIf="isGalleryImageTooLarge === true" style="color: #f44336; font-size: 14px">One or more images exceed
                the gallery image size limit (5MB), please re-select.</p>
            <button mat-button
                [disabled]="this.galleryImages.length === 0 || isGalleryImageUploading === true || isGalleryImageTooLarge"
                [ngClass]="{'deactivated': this.galleryImages.length === 0 || isGalleryImageUploading === true || isGalleryImageTooLarge, 'activated': this.galleryImages.length !== 0 && !this.isGalleryImageUploading && !isGalleryImageTooLarge}"
                style="background: #161616; color: #dedede; width: fit-content; margin-top: 10px;border: 1px solid #dedede;"
                (click)="uploadGalleryImage()">{{isGalleryImageUploading ? 'Uploading...' :
                'Upload'}}</button>
        </form>
        <div class="image_box flex justify-between mt_20">
            <div style="width:calc(50% - 16px);position: relative;" *ngIf="project.images[0]">
                <div
                    style="position: absolute; display: flex; align-items: center;justify-content:flex-end;width: 100%; margin-top: 10px;">
                    <mat-form-field>
                        <mat-label>Position</mat-label>
                        <mat-select class="sort-select"
                            [(ngModel)]="(project.images[0].notes && project.images[0].notes.pos) || project.images[0].pos"
                            (selectionChange)="positionChanged($event, project.images[0])">
                            <mat-option *ngFor="let i of indexes" [value]=i>
                                {{i}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button mat-button (click)="changeImagePosition(project.images[0])"
                        style="color:#161616;background:#fff;">
                        {{project.images[0].isChangingPosition ? 'Saving' : 'Save'}}
                    </button>
                </div>
                <div
                    style="position: absolute; background: rgba(0,0,0,.5); color: #dedede; padding: 10px 20px; width: 100%;box-sizing: border-box; display: flex; justify-content: space-between; align-items: center;margin-top: 337px;">
                    <span style="font-size: 16px; ">{{(project.images[0].notes && project.images[0].notes.pos) ||
                        project.images[0].pos}}</span>
                    <mat-icon style="color: #dedede; cursor:pointer;"
                        (click)="deleteGalleryImage(project.images[0].id)">
                        delete
                    </mat-icon>
                </div>
                <img [src]="SERVER_URL + 'images/' + project.projectCode + '/images/' + project.images[0].fileName"
                    class="first_image">
            </div>

            <div style="width: calc(25% - 16px);position: relative;">
                <div *ngIf="project.images[1]">
                    <div
                        style="position: absolute; display: flex; align-items: center;justify-content:flex-end;width: 100%;box-sizing: border-box;margin-top: 10px; ">
                        <mat-form-field>
                            <mat-label>Position</mat-label>
                            <mat-select class="sort-select"
                                [(ngModel)]="(project.images[1].notes && project.images[1].notes.pos) || project.images[1].pos"
                                (selectionChange)="positionChanged($event, project.images[1])">
                                <mat-option *ngFor="let i of indexes" [value]=i>
                                    {{i}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <button mat-button (click)="changeImagePosition(project.images[1])"
                            style="color:#161616;background:#fff;">
                            {{project.images[1].isChangingPosition ? 'Saving' : 'Save'}}
                        </button>
                    </div>
                    <div
                        style="position: absolute; background: rgba(0,0,0,.5); color: #dedede; padding: 10px 20px; width: 100%;box-sizing: border-box; display: flex; justify-content: space-between; align-items: center;margin-top: 141px;">
                        <span style="font-size: 16px; ">{{(project.images[1].notes && project.images[1].notes.pos) ||
                            project.images[1].pos}}</span>
                        <mat-icon style="color: #dedede; cursor:pointer;"
                            (click)="deleteGalleryImage(project.images[1].id)">
                            delete
                        </mat-icon>
                    </div>
                    <img [src]="SERVER_URL + 'images/' + project.projectCode + '/images/' + project.images[1].fileName"
                        class="second_image">
                </div>
                <div *ngIf="project.images[2]">
                    <div
                        style="position: absolute; display: flex; align-items: center;justify-content:flex-end;width: 100%;box-sizing: border-box;margin-top: 20px; ">
                        <mat-form-field>
                            <mat-label>Position</mat-label>
                            <mat-select class="sort-select"
                                [(ngModel)]="(project.images[2].notes && project.images[2].notes.pos) || project.images[2].pos"
                                (selectionChange)="positionChanged($event, project.images[2])">
                                <mat-option *ngFor="let i of indexes" [value]=i>
                                    {{i}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <button mat-button (click)="changeImagePosition(project.images[2])"
                            style="color:#161616;background:#fff;">
                            {{project.images[2].isChangingPosition ? 'Saving' : 'Save'}}
                        </button>
                    </div>
                    <div
                        style="position: absolute; background: rgba(0,0,0,.5); color: #dedede; padding: 10px 20px; width: 100%;box-sizing: border-box; display: flex; justify-content: space-between; align-items: center;margin-top: 152px;">
                        <span style="font-size: 16px; ">{{(project.images[2].notes && project.images[2].notes.pos) ||
                            project.images[2].pos}}</span>
                        <mat-icon style="color: #dedede; cursor:pointer;"
                            (click)="deleteGalleryImage(project.images[2].id)">
                            delete
                        </mat-icon>
                    </div>
                    <img [src]="SERVER_URL + 'images/' + project.projectCode + '/images/' + project.images[2].fileName"
                        class="second_image mt_15">
                </div>
            </div>
            <div style="width: calc(25% - 16px);">
                <div *ngIf="project.images[3]">
                    <div
                        style="position: absolute; display: flex; align-items: center;justify-content:flex-end;width: calc(23.5% - 38px);margin-top: 10px; ">
                        <mat-form-field>
                            <mat-label>Position</mat-label>
                            <mat-select class="sort-select"
                                [(ngModel)]="(project.images[3].notes && project.images[3].notes.pos) || project.images[3].pos"
                                (selectionChange)="positionChanged($event, project.images[3])">
                                <mat-option *ngFor="let i of indexes" [value]=i>
                                    {{i}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <button mat-button (click)="changeImagePosition(project.images[3])"
                            style="color:#161616;background:#fff;">
                            {{project.images[3].isChangingPosition ? 'Saving' : 'Save'}}
                        </button>
                    </div>
                    <div
                        style="position: absolute; background: rgba(0,0,0,.5); color: #dedede; padding: 10px 20px; width: calc(23.5% - 70px); display: flex; justify-content: space-between; align-items: center;margin-top: 141px;">
                        <span style="font-size: 16px; ">{{(project.images[3].notes && project.images[3].notes.pos) ||
                            project.images[3].pos}}</span>
                        <mat-icon style="color: #dedede; cursor:pointer;"
                            (click)="deleteGalleryImage(project.images[3].id)">
                            delete
                        </mat-icon>
                    </div>
                    <img [src]="SERVER_URL + 'images/' + project.projectCode + '/images/' + project.images[3].fileName"
                        class="second_image">
                </div>
                <div *ngIf="project.images[4]">
                    <div
                        style="position: absolute; display: flex; align-items: center;justify-content:flex-end;width: calc(23.5% - 38px);margin-top: 20px; ">
                        <mat-form-field>
                            <mat-label>Position</mat-label>
                            <mat-select class="sort-select"
                                [(ngModel)]="(project.images[4].notes && project.images[4].notes.pos) || project.images[4].pos"
                                (selectionChange)="positionChanged($event, project.images[4])">
                                <mat-option *ngFor="let i of indexes" [value]=i>
                                    {{i}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <button mat-button (click)="changeImagePosition(project.images[4])"
                            style="color:#161616;background:#fff;">
                            {{project.images[4].isChangingPosition ? 'Saving' : 'Save'}}
                        </button>
                    </div>
                    <div
                        style="position: absolute; background: rgba(0,0,0,.5); color: #dedede; padding: 10px 20px; width: calc(23.5% - 78px); display: flex; justify-content: space-between; align-items: center;margin-top: 152px;">
                        <span style="font-size: 16px; ">{{(project.images[4].notes && project.images[4].notes.pos) ||
                            project.images[4].pos}}</span>
                        <mat-icon style="color: #dedede; cursor:pointer;"
                            (click)="deleteGalleryImage(project.images[4].id)">
                            delete
                        </mat-icon>
                    </div>
                    <img [src]="SERVER_URL + 'images/' + project.projectCode + '/images/' + project.images[4].fileName"
                        class="second_image mt_15">
                </div>
                <!-- <div class="mt_15 second_image black_bg fc_DEDEDE fz_14 flex align-center justify-center"
                    (click)="viewMore()">
                    <div class="cursor_pointer"> View more</div>
                </div> -->
            </div>

        </div>
        <div *ngIf="project.images.length>4" class="mt_20">
            <div *ngFor="let image of project.images | slice:5; let i = index"
                style="display: inline-flex;width: 23.5%;margin-right: 15px;margin-bottom: 20px;">
                <div
                    style="position: absolute; display: flex; align-items: center;justify-content:flex-end;width: calc(23.5% - 30px);margin-top: 10px; ">
                    <mat-form-field>
                        <mat-label>Position</mat-label>
                        <mat-select [(ngModel)]="(image.notes && image.notes.pos) || image.pos"
                            (selectionChange)="positionChanged($event, image)">
                            <mat-option *ngFor="let i of indexes" [value]=i>
                                {{i}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button mat-button (click)="changeImagePosition(image)">
                        {{image.isChangingPosition ? 'Saving' : 'Save'}}
                    </button>
                </div>
                <div
                    style="position: absolute; background: rgba(0,0,0,.5); color: #dedede; padding: 10px 20px; width: calc(23.5% - 70px); display: flex; justify-content: space-between; align-items: center;margin-top: 141px;">
                    <span style="font-size: 16px; ">{{(image.notes && image.notes.pos) || image.pos}}</span>
                    <mat-icon style="color: #dedede; cursor:pointer;" (click)="deleteGalleryImage(image.id)">
                        delete
                    </mat-icon>
                </div>
                <img [src]="SERVER_URL + 'images/' + project.projectCode + '/images/' + image.fileName"
                    style="height: 181px;width: 100%;">


            </div>

        </div>



    </div>
    <!-- <div style="padding-top: 40px; border-bottom: 1px solid rgba(222, 222, 222, 0.2);">
        <h4 style=" margin-bottom: 10px">Extra Images</h4>
        <p style=" font-size: 14px; color: rgba(222, 222, 222, 0.4); margin-top: 0">Multiple images can be uploaded
            together. And each image cannot exceed 5MB</p>
        <div class="img-list">
            
            <div class="add-img">
                <div class="text-center">
                    <img src="../../../../../assets/images/black/add.png"
                        style="width: 32px;height:32px;margin-bottom: 15px;">
                    <div style="font-size: 14px;line-height:16px;color:rgba(222, 222, 222, 0.2);">add more images</div>
                  
                </div>
            </div>
        </div>
    </div> -->
    <!-- <div style="padding-top: 40px; border-bottom: 1px solid rgba(222, 222, 222, 0.2);">
        <h4 style=" margin-bottom: 10px">Your Video Gallery</h4>
        <p style=" font-size: 14px; color: rgba(222, 222, 222, 0.4); margin-top: 0">Multiple videos can be uploaded
            together. And each video cannot exceed 20MB</p>
        <div class="video-list">
            <div class="add-img">
                <div class="text-center">
                    <img src="../../../../../assets/images/black/add.png"
                        style="width: 32px;height:32px;margin-bottom: 15px;">
                    <div style="font-size: 14px;line-height:16px;color:rgba(222, 222, 222, 0.2);">add more videos</div>
                </div>
            </div>
        </div>
    </div>
    <div style="padding-top: 40px;">
        <h4 style=" margin-bottom: 10px">Your 3D Gallery</h4>
        <div class="video-list">
            <div class="add-img">
                <div class="text-center">
                    <img src="../../../../../assets/images/black/add.png"
                        style="width: 32px;height:32px;margin-bottom: 15px;">
                    <div style="font-size: 14px;line-height:16px;color:rgba(222, 222, 222, 0.2);">add another 3D file
                    </div>
                </div>
            </div>
        </div>
    </div> -->


    <app-loading *ngIf="isLoading"></app-loading>

</div>